import * as userServices from '@/services/userServices';
// import * as storageServices from '@/services/storageServices';

export default {
  namespaced: true,
  state: {
    nickname: '',
    photoURL: '',
    selfIntroduction: ''
  },
  mutations: {
    loadPerformerDoc(state, payload) {
      state.nickname = payload.nickname;
      state.photoURL = payload.photoURL;
      state.selfIntroduction = payload.selfIntroduction;
    }
  },
  actions: {
    async loadPerformerDoc({ commit }, performerId) {
      const performerDoc = await userServices.getUserDoc(performerId);
      commit('loadPerformerDoc', {
        nickname: performerDoc.nickname,
        photoURL: performerDoc.photoURL,
        selfIntroduction: performerDoc.selfIntroduction
      });
    }
  },
  getters: {
    performerDoc(state) {
      return state.doc;
    }
  }
};
